import React, { FunctionComponent, useEffect } from 'react'
import { BoldText } from '../Text'
import { SidebarContent } from './styles'
import AsideCompetitionList from '../AsideCompetitionList'
import competitionStore from '../../stores/competitionStore'
import { observer } from 'mobx-react-lite'
import { mapToProps } from '../../utils/helpers'
import competitionPageStore from '../../stores/competitionPageStore'

interface ISimilarCompetitions {
  store: typeof competitionPageStore
}

const SimilarCompetitions: FunctionComponent<ISimilarCompetitions> = observer(({
  store
}) => {
  const competitionCategory = store?.data?.competitionInfo?.category

  useEffect(() => {
    if (competitionCategory) competitionStore.fetchSimilarCompetitions(competitionCategory)
  }, [competitionCategory, store])

  if (!competitionStore.hasSimilarCompetitions) return null

  return (
    <SidebarContent>
      <BoldText variant="medium">SIMILAR COMPETITIONS</BoldText>
      <AsideCompetitionList competitions={competitionStore.similarCompetitions} />
    </SidebarContent>
  )
})

export default mapToProps({ store: competitionStore }, SimilarCompetitions)
